import { AuroraAwhpResponse } from '../types'

export class AuroraAwhpActionNack extends Error {
  constructor(message: AuroraAwhpResponse['action_nack']) {
    super(message)
  }
}

export default AuroraAwhpActionNack
